import { addEntities, upsertEntities } from '@ngneat/elf-entities';
import {createStore} from '@ngneat/elf';
import {
  withEntities,
  selectAllEntities,
  setEntities,
  withActiveId,
  selectEntity
} from '@ngneat/elf-entities';
import {withRequestsCache, withRequestsStatus} from '@ngneat/elf-requests';
import {Injectable} from "@angular/core";
import {CompetentAuthorityModel} from "../models/competent-authority.model";
import { RestService } from '../services/rest.service';
import { map, Observable, take } from 'rxjs';


const storeName = 'competent-authorities';

export const store = createStore(
  {name: storeName},
  withEntities<CompetentAuthorityModel>(),
  withActiveId(),
  withRequestsCache<typeof storeName>(),
  withRequestsStatus<typeof storeName>()
);

@Injectable({providedIn: 'root'})
export class CompetentAuthoritiesRepository {
  competentAuthorities$ = store.pipe(selectAllEntities());

  constructor(
    private _restService: RestService
  ) {
    store.reset();
  }

  loadCompetentAuthorities() {
    this._restService.httpGet('/competent_authorities').pipe(take(1)).subscribe(competentAuthorities => {
      this.setCompetentAuthorities(competentAuthorities);
    });
  }

  createCompetentAuthority(competentAuthority: CompetentAuthorityModel): Observable<CompetentAuthorityModel> {
    return this._restService.httpPost('/competent_authorities', competentAuthority).pipe(
      take(1),
      map((created: CompetentAuthorityModel) => {
        store.update(addEntities(created));
        return created;
      })
    );
  }

  updateCompetentAuthority(id: number, competentAuthority: CompetentAuthorityModel): Observable<CompetentAuthorityModel> {
    return this._restService.httpPut(`/competent_authorities/${id}`, competentAuthority).pipe(
      take(1),
      map((updated: CompetentAuthorityModel) => {
        store.update(upsertEntities(updated));
        return updated;
      })
    );
  }

  searchCompetentAuthorities(searchTerm: string): Observable<CompetentAuthorityModel[]> {
    return this._restService.httpGet(`/competent_authorities?search=${searchTerm}`);
  }

  getCompetentAuthorities() {
    return store.pipe(selectAllEntities());
  }

  getComponentAuthorityById(id: number) {
    return store.pipe(selectEntity(id));
  }

  setCompetentAuthorities(competentAuthorityModels: CompetentAuthorityModel[]) {
    store.update(setEntities(competentAuthorityModels));
  }

  getCompetentAuthoritiesByShelterId(shelterId: number): Observable<CompetentAuthorityModel[]> {
    return store.pipe(selectAllEntities()).pipe(
        take(1),
        map((competentAuthorities: CompetentAuthorityModel[]) => {
          const filteredCompetentAuthorities = competentAuthorities.filter((competentAuthority: CompetentAuthorityModel) => {
            return competentAuthority.animalShelter.id === shelterId;
          });
          return filteredCompetentAuthorities;
        })
      );
    }
}